import { render } from "./transaction.vue?vue&type=template&id=71cc65f8&scoped=true"
import script from "./transaction.vue?vue&type=script&lang=js"
export * from "./transaction.vue?vue&type=script&lang=js"

import "./transaction.vue?vue&type=style&index=0&id=71cc65f8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\admin-tapit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71cc65f8"]])

export default __exports__